import APIS from "../../constant/EndPoint";
import ComboboxInput from "../Reusable/ComboboxInput";
import TextField from "../Reusable/TextInput";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const DeliveryChargeForm = ({
  errors,
  register,
  setValue,
  getValues,
  clearErrors,
}: any) => {
  return (
    <div className={tw`grid grid-cols-1 md:grid-cols-2 gap-x-4 mx-4`}>
      <ComboboxInput
        label={"Pickup Branch"}
        placeholder={"Pickup Branch"}
        url={APIS.BRANCH}
        queryKey={"branch"}
        register={register("pickup_branch")}
        errors={errors?.pickup_branch}
        name={"pickup_branch"}
        props={{ is_active: true }}
        setValue={setValue}
        getValues={getValues}
        clearErrors={clearErrors}
      />
      <ComboboxInput
        label={"Destination City"}
        placeholder={"Destination City"}
        url={APIS.LOCATION}
        props={{ level: 3 ,is_active:true}}
        queryKey={"destination-city"}
        register={register("destination_city")}
        errors={errors?.destination_city}
        name={"destination_city"}
        setValue={setValue}
        getValues={getValues}
        clearErrors={clearErrors}
      />
      <TextField
        label={"Base Weight"}
        register={register("base_weight")}
        errors={errors?.base_weight}
      />
      <TextField
        label={"Base Price"}
        register={register("base_price")}
        errors={errors?.base_price}
      />
      <TextField
        label={"For exceed weight(%By Base weight)"}
        register={register("price_for_exceed_weight")}
        errors={errors?.price_for_exceed_weight}
      />
    </div>
  );
};

export default DeliveryChargeForm;
